<div class="component uk-margin">
  <b>
    {{ cmInput.input_name }}
    @if (cmInput.input_unit && cmInput.input_unit != '' && cmInput.input_unit != null) {
      ({{ cmInput.input_unit }})
    }
  </b>
  @if (cmInput.input_description) {
    <p [innerHTML]="cmInput.input_description"></p>
  }
  @if (devOrLocalhost.getValue() == 'Localhost') {
    <p class="dev-info">
      @if (!calculationModuleService.isCMLayerInput(cmInput)) {
        @if (cmInput.input_type === type_file) {
        } @else {
          Value: {{ cmInput.input_value }} {{ cmInput.input_unit }}
        }
      } @else if (cmInput.layerSelected) {
        {{ cmInput.layerSelected.name }}
      }
    </p>
  }
  <div class="uk-form-controls">
    @switch (cmInput.input_type) {
      @case (type_input) {
        <input
          class="uk-{{ cmInput.input_type }}"
          id="{{ cmInput.input_parameter_name }}"
          type="{{ cmInput.input_type }}"
          min="{{ cmInput.input_min }}"
          max="{{ cmInput.input_max }}"
          value="{{ cmInput.input_value }}"
          placeholder="{{ cmInput.input_name }}"
          (change)="onInputOrRangeInputChange($event)"
        />
        <span class="min-max-values">
          Min: {{ cmInput.input_min }}{{ cmInput.input_unit }}; Max: {{ cmInput.input_max
          }}{{ cmInput.input_unit }};
        </span>
      }
      @case (type_range) {
        <span>Value: {{ cmInput.input_value }}{{ cmInput.input_unit }}</span>
        <input
          class="uk-{{ cmInput.input_type }}"
          id="{{ cmInput.input_parameter_name }}"
          type="{{ cmInput.input_type }}"
          min="{{ cmInput.input_min }}"
          max="{{ cmInput.input_max }}"
          value="{{ cmInput.input_value }}"
          placeholder="{{ cmInput.input_name }}"
          (change)="onInputOrRangeInputChange($event)"
        />
        <span class="min-max-values">
          Min: {{ cmInput.input_min }}{{ cmInput.input_unit }}; Max: {{ cmInput.input_max
          }}{{ cmInput.input_unit }};
        </span>
      }
      @case (type_radio) {
        <div
          class="selection-div"
          [class.column]="cmInput.input_options_array && cmInput.input_options_array.length > 2"
        >
          @for (value of cmInput.input_options_array; track $index) {
            <label
              ><input
                class="uk-{{ cmInput.input_type }}"
                name="{{ cmInput.input_name }}_{{ index }}"
                id="{{ cmInput.input_name }}_{{ index }}"
                value="{{ value }}"
                type="{{ cmInput.input_type }}"
                (change)="onRadioOrSelectInputChange($event)"
                [checked]="cmInput.input_value == value"
              />{{ value }}</label
            >
          }
        </div>
      }
      @case (type_checkbox) {
        <div class="selection-div column">
          @for (value of cmInput.input_options_array; track $index) {
            <label>
              <input
                class="uk-{{ cmInput.input_type }}"
                type="{{ cmInput.input_type }}"
                [value]="value"
                [checked]="isChecked(value)"
                (change)="onCheckboxChange($event)"
              />{{ value }}
            </label>
          }
        </div>
      }
      @case (type_select) {
        <select class="uk-{{ cmInput.input_type }}" (change)="onRadioOrSelectInputChange($event)">
          @for (value of cmInput.input_options_array; track $index) {
            <option
              value="{{ value }}"
              selected="{{ cmInput.input_value == value ? 'selected' : '' }}"
            >
              {{ value }}
            </option>
          }
        </select>
      }
      @case (type_date) {
        <input
          class="uk-input"
          id="{{ cmInput.input_parameter_name }}"
          type="datetime-local"
          (change)="onDateInputChange($any($event.target).value)"
          value="{{ cmInput.input_value }}"
          [attr.min]="cmInput.input_min"
          [attr.max]="cmInput.input_max"
          step="3600"
        />
      }
      @case (type_file) {
        <div class="file-input-wrapper">
          <input
            class="uk-input"
            type="file"
            [attr.accept]="getFileAcceptAttr()"
            (change)="onFileChange($event)"
          />

          <span class="min-max-values">
            {{ getFileHintLabel() }}
          </span>

          @if (fileError() != null) {
            <p class="file-error">{{ fileError() }}</p>
          }
        </div>
      }
    }
    @if (calculationModuleService.isCMLayerInput(cmInput)) {
      <div class="layer-input-container">
        @if (cmInput.layers.length > 0) {
          <select
            class="uk-select"
            [value]="cmInput.layerSelected?.name"
            (change)="setLayerNeeded(cmInput, $event)"
          >
            @for (layer of cmInput.layers; track $index) {
              @if (layer.category != 'Calculation module') {
                <option [value]="layer.name">{{ layer.name }}</option>
              }
            }
          </select>
        } @else {
          <p>No layers found</p>
        }
      </div>
    }
  </div>
</div>
